import React, { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreateOrderBundleModal from '@modals/CreateOrderBundleModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateOrderBundleModal: {
      closeModal: () => setState({ showCreateOrderBundleModal: false }),
      createOrderBundle: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateOrderBundleModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateOrderBundleModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateOrderBundleModal: () => setState({ showCreateOrderBundleModal: true }),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateOrderBundleModal
          callbacks={callbacks('CreateOrderBundleModal', setState)}
          showModal={showCreateOrderBundleModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
